import { Box, Button, Divider } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
import { DocumentTitle } from 'src/routes/components';

import { SimpleLayout } from 'src/layouts/simple';
import { AccountPopover } from 'src/layouts/components/account-popover';
import { HorizontalLinearStepper } from 'src/pages/create-job/components/job-create-stepper';
import { JobStepperContextProvider } from 'src/pages/create-job/context/job-stepper-context-provider';

import { Iconify } from 'src/components/iconify';

const LayoutCreateJob = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  return (
    <JobStepperContextProvider>
      <DocumentTitle />
      <SimpleLayout
        slotProps={{
          footer: { sx: { display: 'none' } },
          header: {
            slots: {
              rightArea: (
                <Box>
                  <AccountPopover data={[]} />
                </Box>
              ),
              leftArea: (
                <Box>
                  <Button
                    size="small"
                    startIcon={<Iconify icon="mdi:arrow-left" width={16} />}
                    sx={{
                      color: 'text.primary',
                      backgroundColor: 'common.white',
                      minWidth: { xs: 0, sm: 'auto' },
                      px: { xs: 1, sm: 1.5 },
                      '& .MuiButton-startIcon': {
                        mr: { xs: 0.5, sm: 1 },
                        '& svg': {
                          width: { xs: 14, sm: 16 },
                          height: { xs: 14, sm: 16 },
                        },
                      },
                    }}
                    onClick={() => router.push(paths.jobs.root)}
                  >
                    <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
                      Back
                    </Box>
                    <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
                      Back to Jobs
                    </Box>
                  </Button>
                </Box>
              ),
              centerArea: <HorizontalLinearStepper />,
              bottomArea: <Divider />,
            },
            slotProps: {
              centerArea: {
                sx: {
                  mx: 3,
                  maxWidth: '780px',
                },
              },
              container: {
                sx: {
                  justifyContent: 'space-between',
                },
              },
            },
          },
          content: {},
        }}
        sx={{
          backgroundImage: (theme) => (theme.palette as any).backgroundImage,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        {children}
      </SimpleLayout>
    </JobStepperContextProvider>
  );
};

export default LayoutCreateJob;
